import { createSlice } from '@reduxjs/toolkit'
import User from "../../Models/User";
import Api from "../../Services/Api";


const initialState = {
    logged: null,
    rdy: false
}


export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        updateUser: (state, action) => {
            state.name = action.payload.user.name
            state.email = action.payload.user.email
            state.is_admin = action.payload.user.is_admin === 1
            state.supplyFeeds = action.payload.supplyFeeds
            state.demandFeeds = action.payload.demandFeeds
            state.publishers = action.payload.publishers
            state.demandFeedTypes = action.payload.demandFeedTypes
            state.rdy = true
            state.logged = true
            state.role = action.payload.user.role
            state.stats = action.payload.stats
        },
        logged: (state, action) => {
            state.logged = action.payload
        },
        updateUserSupplyFeeds: (state, action) => {
            state.supplyFeeds = action.payload
        },
        updateUserDemandFeeds: (state, action) => {
            state.demandFeeds = action.payload
        },
        reset: () => initialState

    }
})

// Action creators are generated for each case reducer function
export const { updateUser, logged, updateUserSupplyFeeds,updateUserDemandFeeds, reset } = usersSlice.actions

export default usersSlice.reducer